module.exports = __webpack_public_path__ + "static/media/hero-royal.8fa48c14.jpg";